import { render, staticRenderFns } from "./UserFullStory.vue?vue&type=template&id=36c7d482&scoped=true&"
import script from "./UserFullStory.vue?vue&type=script&lang=js&"
export * from "./UserFullStory.vue?vue&type=script&lang=js&"
import style0 from "./UserFullStory.vue?vue&type=style&index=0&id=36c7d482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c7d482",
  null
  
)

export default component.exports